import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Badge, Button, ButtonProps } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from '@mui/material/styles';
import React from "react";

interface StyledButtonProps extends Omit<ButtonProps, "startIcon"> {
    startIcon?: React.ReactNode | [IconProp, string];
    dataIndex?: string;
}
  
const CustomButton = styled(Button)<ButtonProps>(({ theme }) => ({
    textTransform: 'none', // Disable uppercase transformation
    borderRadius: '9999px', // Fully rounded corners
    padding: '3px 17px',
	fontSize: 16,
}));

CustomButton.defaultProps = {
    variant: 'contained', 
    size: 'small', 
};
  
export default function StyledButton({ children, dataIndex, startIcon, ...props }: StyledButtonProps): JSX.Element {
    
    let icon: React.ReactNode;
    if (Array.isArray(startIcon)) {
        const [iconProp, iconClassName] = startIcon;
        icon = <FontAwesomeIcon icon={iconProp} className={iconClassName} />;
    } else {
        icon = startIcon;
    }

    return (
        <CustomButton data-index={dataIndex} startIcon={icon} {...props}>
            {children}
        </CustomButton>
    );
}

